import React from 'react'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import PanelKinerja from 'app/KinerjaPage/components/PanelKinerja'
import useContentContext from 'app/KinerjaPage/hooks/useContentContext'
import useSKP from 'app/KinerjaPage/hooks/useSKP'
import StickyFooter from 'app/KinerjaPage/components/StickyFooter'
import useToggleSdkContext from 'utils/useToogleSdk'

import type { Kinerja } from 'types/kinerja'

import IconBookRaporGraphicDoc from 'assets/icons/img-book-rapor-graphic-doc.svg'

const NUMBER_PRAKTIK_PEMBELAJARAN = 1

interface TabHasilKerjaUtamaProps {
  skp: Kinerja
  onClickNext?: () => void
}

const TabHasilKerjaUtama = ({
  skp,
  onClickNext = () => {},
}: TabHasilKerjaUtamaProps) => {
  const toggles = useToggleSdkContext()
  const { getKinerjaUtamaById } = useContentContext()
  const {
    getChangesPraktikPembelajaran,
    getChangesPengembanganKompetensiByIndex,
  } = useSKP(skp)
  const {
    originalKinerja: originalPraktikPembelajaran,
    kinerja: praktikPembelajaran,
  } = getChangesPraktikPembelajaran()

  const isHidePointEnabled =
    toggles?.['kinerja-hide-rhk-point-enabled'] === true
  const isNewFlow = isHidePointEnabled && skp.tahun > 2024

  return (
    <>
      <div className="p-9">
        <div className="flex flex-col gap-9">
          {skp.status === 'APPROVED' && (
            <div className="flex gap-3">
              <IconBookRaporGraphicDoc className="w-16 h-16 shrink-0" />
              <div>
                <Text variant="display-sm">
                  Cek Perencanaan Kinerja yang disetujui atasan
                </Text>
                <Text className="mt-1.5">
                  Kata “Ada penyesuaian” artinya atasan mengubah Rencana Hasil
                  Kerja Anda. Mohon perhatikan dan lanjut sepakati, ya.
                </Text>
              </div>
            </div>
          )}

          <PanelKinerja
            data-testid="praktikPembelajaran"
            number={NUMBER_PRAKTIK_PEMBELAJARAN}
            originalKinerja={originalPraktikPembelajaran}
            kinerja={praktikPembelajaran}
            showChange
            showDetails={!isNewFlow}
          />

          {skp.reviewPengembanganKompetensi.map((_, index) => {
            const numberingOffset = 1 // Static value for the amount of praktikPembelajaran
            const { originalNumber, originalKinerja, kinerja } =
              getChangesPengembanganKompetensiByIndex(index)
            const number = numberingOffset + index + 1

            return (
              <PanelKinerja
                key={`pengembanganKompetensi-${index}`}
                data-testid={`pengembanganKompetensi-${index}`}
                originalKinerjaNumber={numberingOffset + originalNumber}
                originalKinerja={originalKinerja}
                number={number}
                kinerja={kinerja}
                kinerjaNumber={number}
                showChange
                showDetails={!isNewFlow}
              />
            )
          })}

          {skp.kinerjaUtama.map((id, index) => {
            const numberingOffset = 1 + skp.reviewPengembanganKompetensi.length // 1 is static value for the amount of praktikPembelajaran
            const number = numberingOffset + index + 1
            const kinerjaUtama = getKinerjaUtamaById(id)

            return (
              <PanelKinerja
                key={`kinerjaUtama-${index}`}
                data-testid={`kinerjaUtama-${index}`}
                number={number}
                kinerja={kinerjaUtama}
                showDetails={!isNewFlow}
              />
            )
          })}
        </div>
      </div>

      <StickyFooter>
        <Button
          size="lg"
          color="black"
          onClick={() => onClickNext()}
          type="button"
          data-testid="btn-next"
        >
          Ke Hasil Kerja Tambahan
        </Button>
      </StickyFooter>
    </>
  )
}

export default TabHasilKerjaUtama
